import { Icon, SplitColumnsContainer } from '@startlibs/components'
import { Combobox, Errors, FormValue, RadioboxGroup, SimpleCheckbox, SimpleRadiobox, TextInput,  useFormValue } from '@startlibs/form'
import { getColor, smoothScroll } from '@startlibs/utils';
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';
import { LOCAL_PHYSICIAN, REF_PHYSICIAN } from '../../enums/ContactRelationType'
import { ConfirmEmailInput } from '../../components/ConfirmEmailInput'
import { getFormattedStates } from '../PatientAndContactDetailsNew';
import { ComboboxContainer } from './ContactDetailsNew';
import { AddButton } from '../../components/AddButton';
import StyledTelInput1 from '../../components/StyledTelInput1';
import { IntakeFormCard } from './PatientDetailsNew';
import { FormattedMessage, useIntl } from 'react-intl';

export const AddressHeading = styled.div`
  font-size: 13px;
  color: ${getColor('gray150')};
  padding-bottom: .25rem;
  border-bottom: 1px solid ${getColor('gray210')};
  margin: 1.5rem 0;
`

const VIEWPORT_MIN_WIDTH = 500

const CloseIcon = styled(Icon)`
  position: absolute;
  right: -0.25rem;
  top: -0.25rem;
  color: #f0f0f0;
  background: #787878;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 50%;
  text-align: center;
  padding: 4px;
  font-size: 18px;
  z-index: 999;
  padding: 0;
  :hover {
    background: #6b6b6b;
  }
`

export const ReferringPhysicianNew = ({ title, subTitle, scrollTo, readOnly, isAdmin, form, countryList, showSelects, 
  physicianPhoneNumber1Valid, setPhysicianPhoneNumber1Valid,
  physicianFaxNumber1Valid, setPhysicianFaxNumber1Valid,
  physicianPhoneNumber2Valid, setPhysicianPhoneNumber2Valid,
  physicianFaxNumber2Valid, setPhysicianFaxNumber2Valid,
  NavigationButtons}) => {

  const [relationType] = useFormValue('contactDetails.contactRelationType')

  const intl = useIntl()
  const headerRef = useRef()
  
  useEffect(() => {
    if (scrollTo) {
      smoothScroll({ target: headerRef.current, offset: -200 })
    }
  }, [])

  useEffect(() => {
    // if there is no physician, add one
    if (!form.getValue('referringPhysicians') || form.getValue('referringPhysicians').length === 0) {
      form.setValue('referringPhysicians', [{
        role:  (relationType === LOCAL_PHYSICIAN || relationType === REF_PHYSICIAN) 
          ? relationType === LOCAL_PHYSICIAN 
            ? REF_PHYSICIAN 
            : LOCAL_PHYSICIAN 
          : REF_PHYSICIAN
      }]);
    }
    if(form.getValue('referringPhysicians').length === 1){
      if(relationType === LOCAL_PHYSICIAN || relationType === REF_PHYSICIAN){
        form.setValue('referringPhysicians[0].role',  relationType === LOCAL_PHYSICIAN ? REF_PHYSICIAN : LOCAL_PHYSICIAN);
      }
    }

  }, [])
  // Function to add a new physician
  const addPhysician = () => {
    const physicians = form.getValue('referringPhysicians') || [];
    let nextPhysicianRole = '';
    if (physicians.length > 0) {
      if(physicians[0].role === REF_PHYSICIAN) {
        nextPhysicianRole = LOCAL_PHYSICIAN;
      }else{
        nextPhysicianRole = REF_PHYSICIAN
      }
      form.setValue('referringPhysicians', [...physicians, {role: nextPhysicianRole}]);  
    }
    
  };

  // Function to remove a physician
  const removePhysician = (index) => {
    const physicians = form.getValue('referringPhysicians') || [];
    const newPhysicians = physicians.filter((physician, i) => i !== index);
    form.setValue('referringPhysicians', newPhysicians);
  };
  
  const canHaveTwoPhysicians = relationType !== LOCAL_PHYSICIAN && relationType !== REF_PHYSICIAN
  // if (relationType === REF_PHYSICIAN) {
  //   return null
  // }

  return <>
    {/* <SectionHeading>
      <h3>Referring physician</h3>
      <p>
        This physician can be requested to take action on this case and may
        receive a copy of any resulting reports.
      </p>
    </SectionHeading> */}
    <IntakeFormCard>
      <div>
      {title && <h3 ref={headerRef}>{title}</h3>}
      {subTitle && <p>{subTitle}</p>}
      <FormValue path="referringPhysicians">{
        (referringPhysicians = [{}]) => 
          referringPhysicians.map((physician, index) => ( 
            <div key={index} 
              style={{
                backgroundColor: index === 0 ? 'white' : '#f2f2f2', 
                padding: index === 0 ? '0px' : '1rem', 
                marginBottom: index === 0 ? '1rem' : '0.5rem',
                borderRadius: index === 0 ? '0px' : '6px',
                border: index === 0 ? 'none' : '1px solid #d9d9d9',
                position: index === 0 ? 'inherit' : 'relative'
              }}
            >
              {index === 1 && <CloseIcon icon='x' 
                // style={{
                //   position: 'absolute', right: '1rem', top: '0rem',
                //   cursor: 'pointer',
                //   background: 'black',
                //   color: 'white',
                //   borderRadius: '60px',
                //   padding: '4px',
                //   width: '18px',
                //   height: '18px',
                //   textAlign: 'center',
                //   fontSize: '18px',
                //   cursor: 'pointer',
                //   zIndex: 999
                // }} 
                onClick={() => {
                  removePhysician(index)} 
                }/>}
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">

                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].fullName.first`}
                  label={intl.formatMessage({ defaultMessage: "First name", description: "Physician step first name" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: John", description: "Physician step first name" })}
                  maxLength={255}
                />

                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].fullName.last`}
                  label={intl.formatMessage({ defaultMessage: "Last name", description: "Physician step last name" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: Doe", description: "Physician step last name" })}
                  maxLength={255}
                />
              </SplitColumnsContainer>
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                <RadioboxGroup 
                  disabled={readOnly} 
                  // label="Physician role" 
                  label={intl.formatMessage({ defaultMessage: "Physician role", description: "Physician role" })}
                  horizontal 
                  path={`referringPhysicians[${index}].role`}
                  framedBoxes 
                  wide
                >
                  <SimpleRadiobox fieldValue={REF_PHYSICIAN}   label={intl.formatMessage({ defaultMessage: "Referring", description: "Physician role Referring" })} disabled={relationType === REF_PHYSICIAN}/>
                  <SimpleRadiobox fieldValue={LOCAL_PHYSICIAN} label={intl.formatMessage({ defaultMessage: "Local", description: "Physician role Local" })} disabled={relationType === LOCAL_PHYSICIAN} />
                </RadioboxGroup>
                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].institution`}
                  label={intl.formatMessage({ defaultMessage: "Institution", description: "Physician step institution" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: Purview", description: "Physician step institution" })}
                  maxLength={255}
                />
              </SplitColumnsContainer>
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                {showSelects ? <>
                  <ComboboxContainer readOnly={readOnly} className='fs-exclude'><Combobox
                    disabled={readOnly}
                    className="combobox fs-exclude"
                    label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
                    placeholder={intl.formatMessage({ defaultMessage: "Please select country", description: "PatientDetails country select placeholder" })}
                    path={`referringPhysicians[${index}].address.country`}
                    options={countryList}
                    onChange={(val) => {
                      var states = getFormattedStates(val)
                      if (states.length > 0) {
                        if (states.findIndex(x => x === form.getValue(`referringPhysicians[${index}].address.state`)) == -1) {
                          form.setValue(`referringPhysicians[${index}].address.state`, null)
                        }
                      }
                    }}
                  /></ComboboxContainer>
                  <FormValue path={`referringPhysicians[${index}].address.country`}>{country =>
                    <ComboboxContainer readOnly={readOnly} className='fs-exclude'>
                      <Combobox
                        disabled={readOnly}
                        className="combobox fs-exclude"
                        label={intl.formatMessage({ defaultMessage: "State/Province", description: "PatientDetails state label" })}
                        placeholder={intl.formatMessage({ defaultMessage: "Please select state", description: "PatientDetails state select placeholder" })}
                        path={`referringPhysicians[${index}].address.state`}
                        options={getFormattedStates(country)}
                      />
                    </ComboboxContainer>
                  }</FormValue>
                </> : <>
                  <TextInput
                    disabled={readOnly}
                    type="text"
                    path={`referringPhysicians[${index}].address.country`}
                    label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
                    placeholder={intl.formatMessage({ defaultMessage: "Ex: USA", description: "PatientDetails country placeholder" })}
                    maxLength={255}
                  />
                  <TextInput
                    disabled={readOnly}
                    type="text"
                    path={`referringPhysicians[${index}].address.state`}
                    label={intl.formatMessage({ defaultMessage: "State", description: "PatientDetails state label" })}
                    placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails state placeholder" })}
                    maxLength={255}
                  />
                </>}
              </SplitColumnsContainer>
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].address.city`}
                  label={intl.formatMessage({ defaultMessage: "City", description: "PatientDetails city label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails city placeholder" })}
                  maxLength={255}
                />
                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].address.zipCode`}
                  label={intl.formatMessage({ defaultMessage: "Postal code", description: "PatientDetails postal code label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: 12345", description: "PatientDetails postal code placeholder" })}
                  maxLength={255}
                />
              </SplitColumnsContainer>
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].address.address`}
                  label={intl.formatMessage({ defaultMessage: "Street address - Line 1", description: "PatientDetails street address line 1 label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: 001 Street Name", description: "PatientDetails street address line 1 placeholder" })}
                  maxLength={255}
                />
                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].address.address2`}
                  label={intl.formatMessage({ defaultMessage: "Street address - Line 2", description: "PatientDetails street address line 2 label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: PO BOX 001", description: "PatientDetails street address line 2 placeholder" })}
                  maxLength={255}
                />
              </SplitColumnsContainer>
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                <TextInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].email`}
                  label={intl.formatMessage({ defaultMessage: "Email address", description: "Physician email address label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: physicians@email.com", description: "Physician email address placeholder" })}
                  maxLength={255}
                />
                <ConfirmEmailInput
                  disabled={readOnly}
                  type="text"
                  path={`referringPhysicians[${index}].confirmEmail`}
                  confirmingPath={`referringPhysicians[${index}].email`}
                  label={intl.formatMessage({ defaultMessage: "Confirm email", description: "Physician confirm email address label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "Ex: physicians@email.com", description: "Physician email address placeholder" })}
                  maxLength={255}
                  mandatory={false}
                  canLock={false}
                />
              </SplitColumnsContainer>
              <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                
                <StyledTelInput1
                  path={['referringPhysicians', index, 'phoneNumber']}
                  hasErrors={form.hasErrors()}
                  label={intl.formatMessage({ defaultMessage: "Phone number", description: "ContactDetails phone number label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails phone number placeholder" })}
                  disabled={readOnly}
                  initOptions={{
                    initialCountry: "us",
                    separateDialCode: false,
                    autoPlaceholder: "aggressive",
                    formatOnDisplay: true,
                    placeholderNumberType: "FIXED_LINE_OR_MOBILE",
                    nationalMode: false,
                    countryOrder: ["us"],
                    validationNumberType: "FIXED_LINE_OR_MOBILE"
                  }}
                  tabIndex={1}
                  isValid={index === 0 ? physicianPhoneNumber1Valid : physicianPhoneNumber2Valid}
                  setIsValid={index === 0 ? setPhysicianPhoneNumber1Valid : setPhysicianPhoneNumber2Valid}
                />
                <StyledTelInput1
                  // mandatory 
                  path={`referringPhysicians[${index}].faxNumber`}
                  hasErrors={form.hasErrors()}
                  label={intl.formatMessage({ defaultMessage: "Fax number", description: "ContactDetails fax number label" })}
                  placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails fax number placeholder" })}
                  disabled={readOnly}
                  initOptions={{
                    initialCountry: "us",
                    separateDialCode: false,
                    autoPlaceholder: "aggressive",
                    formatOnDisplay: true,
                    placeholderNumberType: "FIXED_LINE_OR_MOBILE",
                    nationalMode: false,
                    countryOrder: ["us"],
                    validationNumberType: "FIXED_LINE_OR_MOBILE"
                  }}
                  tabIndex={1}
                  isValid={index === 0 ? physicianFaxNumber1Valid : physicianFaxNumber2Valid}
                  setIsValid={index === 0 ? setPhysicianFaxNumber1Valid : setPhysicianFaxNumber2Valid}
                />
                  {isAdmin && <TextInput
                    disabled={readOnly}
                    type="text"
                    path={`referringPhysicians[${index}].npi`}
                    label={intl.formatMessage({ defaultMessage: "NPI", description: "ContactDetails npi label" })}
                    placeholder={intl.formatMessage({ defaultMessage: "Ex: 1234567890", description: "ContactDetails npi placeholder" })}
                    maxLength={255}
                  />}
              </SplitColumnsContainer>
              {/* <FormValue path="referringPhysician.acceptContact"> */}
              <FormValue path={`referringPhysicians[${index}].acceptContact`}>{acceptContact =>
                acceptContact !== null && <>
                  {isAdmin && <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
                    <SimpleCheckbox
                      disabled={readOnly}
                      // path="referringPhysician.acceptContact"
                      path={`referringPhysicians[${index}].acceptContact`}
                      label={<span css="font-size:13px;">
                        <FormattedMessage
                          defaultMessage={"This physician has been made aware of this case, and can be contacted as necessary"}
                          description={"Physician made aware accept contact label"}
                        />
                      </span>}
                    />
                  </SplitColumnsContainer>}
                </>}
              </FormValue>
              {index === 0 && referringPhysicians.length < 2 && canHaveTwoPhysicians && <AddButton css="margin-top:2rem;" onClick={addPhysician}>
                <FormattedMessage
                  defaultMessage={"Add a physician with another role"}
                  description={"Physician Add physician another role"}
                />
              </AddButton>}
            </div>
          )
        ) 
      }</FormValue>
      </div>
      <Errors path="referringPhysicians" />
      <NavigationButtons /> 
    </IntakeFormCard>
  </>
}
